import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import SessionsComp from './SessionsComp';

function Sessions() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <SessionsComp />
      </div>
    </div>
  );
}

export default Sessions;
